import React from "react";
import AboutResults from "./AboutResults";
import CloseAccount from "./CloseAccount";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsCondition from "./TermsCondition";
import { useSelector } from "react-redux";

function PopupsHandler(props) {
  const { popupComponent } = useSelector((state) => state.ui);
  return (
    <>
      <AboutResults show={popupComponent == "AboutResults"} />
      <CloseAccount show={popupComponent == "CloseAccount"} />
      <PrivacyPolicy show={popupComponent == "PrivacyPolicy"} />
      <TermsCondition show={popupComponent == "TermsCondition"} />
    </>
  );
}

export default PopupsHandler;
